import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
    }

    .lisa-layout {
      grid-template-rows:
        var(--block-top-padding)
        auto
        auto
        var(--block-bottom-padding);
      max-width: 100%;
    }

    .lisa-intro {
      grid-column: 2 / 8;
      grid-row: 2;
      display: grid;
      grid-template-columns: 1fr;
      row-gap: calc(16rem / var(--default-rem-px-count));
    }

    .lisa-header {
      color: var(--block-text-color, #222);
    }

    .lisa-description {
      color: var(--block-text-color, #222);
    }

    .lisa-grid {
      grid-column: 2 / 8;
      grid-row: 3;
      /* Carried here from the layout's row gap, which the padding rows
         would otherwise pick up too. */
      margin-top: calc(40rem / var(--default-rem-px-count));
      display: grid;
      grid-template-columns: 1fr;
      column-gap: calc(32rem / var(--default-rem-px-count));
      row-gap: calc(48rem / var(--default-rem-px-count));
    }

    .lisa-tile {
      display: flex;
      flex-direction: column;
      color: var(--block-text-color, #222);
    }

    .lisa-tile-image {
      display: block;
      width: 100%;
      aspect-ratio: 680 / 409;
      background-color: #d9d9d9;
      overflow: hidden;
    }

    .lisa-tile-image img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .lisa-tile-caption {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      gap: calc(16rem / var(--default-rem-px-count));
      padding-top: calc(16rem / var(--default-rem-px-count));
    }

    .lisa-tile-title {
      /* H2 scale on an h3 tag — pinned so the h3 default doesn't apply. */
      font-size: var(--fs-headline);
      line-height: var(--lh-headline);
      letter-spacing: var(--ls-headline);
      flex: 1 1 auto;
      min-width: 0;
    }

    /* The caption row is baseline-aligned, but cta-text sets align-self on
       its own :host; only a rule from out here lets it join the group. */
    .lisa-tile-cta {
      flex: 0 0 auto;
      align-self: baseline;
    }

    @media (min-width: 600px) {
      /* Top-row texts share a first baseline. */
      .lisa-intro {
        grid-column: 2 / 14;
        grid-template-columns: 1fr 1fr;
        align-items: baseline;
        column-gap: calc(32rem / var(--default-rem-px-count));
      }

      .lisa-grid {
        grid-column: 2 / 14;
        grid-template-columns: 1fr 1fr;
        row-gap: calc(64rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      .lisa-intro {
        grid-column: 2 / 10;
      }
    }
  `,
];
